import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from "react-icons/fa";
import "./Contact.css";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_jd0fijo",
        "template_yn2maae",
        form.current,
        "-gUILpWwik-F7cdou"
      )
      .then(
        (result) => {
          alert("Message envoyé avec succès ✅");
          form.current.reset();
        },
        (error) => {
          alert("Erreur lors de l’envoi ❌");
          console.log(error.text);
        }
      );
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        <h2>
          Contactez <span>Alwalid Holding</span>
        </h2>

        <div className="contact-content">
          {/* Informations */}
          <div className="contact-info">
            <p>
              <FaEnvelope /> contact@alwaleed.sn
            </p>
            <p>
              <FaMapMarkerAlt /> Cité Onomo, Route de l’Aéroport – Dakar, Sénégal
            </p>
          </div>

          {/* Formulaire */}
          <form ref={form} onSubmit={sendEmail} className="contact-form">
            <input type="text" name="user_name" placeholder="Votre nom" required />
            <input type="email" name="user_email" placeholder="Votre email" required />
            <input type="text" name="subject" placeholder="Sujet" />
            <textarea name="message" rows="5" placeholder="Votre message" required></textarea>
            <button type="submit">Envoyer</button>
          </form>
        </div>

        {/* QR CODE + BOUTON WHATSAPP */}
  {/* === WhatsApp Section === */}
<div className="whatsapp-box">
  <h2>📱 Chat WhatsApp</h2>

  <div className="whatsapp-content">
    <img
      src="https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=https://wa.me/221776381733"
      alt="QR Code WhatsApp"
      className="qr-code"
    />

    <a
      href="https://wa.me/221776381733"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-btn"
    >
      <i className="fa-brands fa-whatsapp"></i> Discuter sur WhatsApp
    </a>
  </div>
</div>


      </div>

      {/* Google Maps */}
      <div className="map-container">
        <iframe
          title="Localisation Alwaleed Holding"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3850.400072066442!2d-17.4879446854787!3d14.73923478973154!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xec173843b07e0a1%3A0x8a14263bfaeebc7!2sCIT%C3%89%20ONOMO%20-%20Route%20de%20l%E2%80%99A%C3%A9roport%2C%20Dakar!5e0!3m2!1sfr!2ssn!4v1730610530000!5m2!1sfr!2ssn"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </section>
  );
};

export default Contact;
